<template>
  <div
    class="tab-pane fade show active"
    id="nav-Recent"
    role="tabpanel"
    aria-labelledby="nav-Recent-tab"
    tabindex="0"
  >
    <div class="table-responsive">
      <a-table class="table datatable" :columns="columns" :data-source="data">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'Court_Name'">
            <h2 class="table-avatar">
              <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"
                ><img
                  class="avatar-img"
                  :src="require(`@/assets/img/booking/${record.Image}`)"
                  alt="User"
              /></a>
              <span class="table-head-name flex-grow-1">
                <a
                  href="javascript:;"
                  data-bs-toggle="modal"
                  data-bs-target="#request-court"
                  >{{ record.Court_Name }}</a
                >
                <span>{{ record.Court }}</span>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Player_Name'">
            <h2 class="table-avatar">
              <router-link to="/coaches/my-profile" class="avatar avatar-sm flex-shrink-0">
                <img
                  class="avatar-img"
                  :src="require(`@/assets/img/profiles/${record.Avatar}`)"
                  alt="User"
                />
              </router-link>
              <span class="table-head-name table-name-user flex-grow-1">
                <router-link to="/coaches/my-profile">{{ record.Player_Name }}</router-link>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Date'">
            <div class="table-date-time">
              <h4>
                {{ record.Date }}<span>{{ record.Time }}</span>
              </h4>
            </div>
          </template>
          <template v-else-if="column.key === 'Payment'">
            <div>
              <span class="pay-dark">{{ record.Payment }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'Status'">
            <div class="paid-edit">
              <span><i class="feather-edit"></i>{{ record.Status }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'action'">
            <td class="table-accept-btn text-end">
              <a href="javascript:;" class="btn accept-btn"
                ><i class="feather-check-circle"></i>Accept</a
              >
              <a
                href="javascript:;"
                class="btn cancel-table-btn"
                data-bs-toggle="modal"
                data-bs-target="#request-reject"
                ><i class="feather-x-circle"></i>Cancel</a
              >
            </td>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
const data = [
  {
    Image: "booking-04.jpg",
    Court_Name: "Bwing Sports Academy",
    Court: "Court 3",
    Player_Name: "Pranika",
    Avatar: "avatar-06.jpg",
    Date: "Wed, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Additional_Guests: 2,
    Payment: "$130",
    Status: "Paid",
  },
  {
    Image: "booking-01.jpg",
    Court_Name: "Feather Badminton",
    Court: "Court 2",
    Avatar: "avatar-02.jpg",
    Player_Name: "Andy",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Additional_Guests: 2,
    Payment: "$150",
    Status: "Paid",
  },
  {
    Image: "booking-05.jpg",
    Court_Name: "Marsh Academy",
    Court: "Court 4",
    Player_Name: "Ariyan",
    Avatar: "avatar-03.jpg",
    Date: "Wed, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Additional_Guests: 2,
    Payment: "$120",
    Status: "Paid",
  },
  {
    Image: "booking-01.jpg",
    Court_Name: "Wing Sports Academy",
    Court: "Court 1",
    Avatar: "avatar-01.jpg",
    Player_Name: "Johnson",
    Date: "Fri, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Additional_Guests: 2,
    Payment: "$250",
    Status: "Paid",
  },
];

const columns = [
  {
    title: "Court Name",
    dataIndex: "Court_Name",
    key: "Court_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Court_Name.toLowerCase();
        b = b.Court_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Player Name",
    dataIndex: "Player_Name",
    key: "Player_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Player_Name.toLowerCase();
        b = b.Player_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Additional Guests",
    dataIndex: "Additional_Guests",
    sorter: {
      compare: (a, b) => {
        a = a.Additional_Guests.toLowerCase();
        b = b.Additional_Guests.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
export default {
  data() {
    return {
      columns,
      data,
    };
  },
};
</script>
